import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const API_URL = `${BASE_URL}api/sub-category/get-all-sub-categories`;
export const fetchSubCategories = async () => {
  try {
    const response = await axios.get(API_URL);
    console.log("Subcategories response:", response.data);

    if (response.data.success) {
      return response.data.data.map((subCategory, index) => ({
        id: index + 1,
        originial_id: subCategory.sub_category_id,
        name: subCategory.title,
        category: subCategory.category?.title || "Unknown",
        status: subCategory.is_active,
        description: subCategory.description,
        category_id: subCategory.category_id,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return [];
  }
};

const API_URL_1 = `${BASE_URL}api/category/get-categories-with-product-count`;
export const fetchCategorieswithProductcount = async () => {
  try {
    const response = await axios.get(API_URL_1);
    if (response.data.success) {
      return response.data.data.map((category, index) => ({
        id: index + 1,
        originial_id: category.category_id,
        name: category.category_title,
        subCategories: category.sub_category_count,
        products: category.product_count,
        status: category.is_active,
        description: category.description,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const fetchCategoriesService = async () => {
  try {
    const response = await axios.get(`${BASE_URL}api/category/?is_all=true`);
    console.log("Categories response:", response.data);
    if (response?.data?.success) {
      return response?.data?.data
    }
    return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw new Error(error?.response?.message || "Failed to fetch categories");
    ;
  }
};

export const fetchActiveCategories = async () => {
  try {
    const response = await axios.get(`${BASE_URL}api/category/?is_all=true`);
    console.log("Categories response:", response.data);
   

   
    if (response?.data?.success) {
      const categories = response.data.data;

      const activeCategories = categories
        
        .map(({ category_id, title }) => ({
          id: category_id,
          name: title,
        }));

      return activeCategories;
    }

    return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const addCategory = async (categoryData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/category`,
      categoryData
    );
    return response.data;
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};
export const updateCategory = async (categoryData) => {
  console.log("backend update category:", categoryData)
  
  try {
    const response = await axios.put(
      `${BASE_URL}api/category/update-category`, // Make sure to replace with your correct URL
      categoryData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};
export const updateSubCategory = async ( subCategoryData) => {
  try {
   
    const response = await axios.put(`${BASE_URL}api/sub-category/update-sub-category`, subCategoryData);
    
    
    return response.data;
  } catch (error) {
    console.error("Error updating subcategory:", error);
    
   
    throw error;
  }
};

export const addSubCategory = async (subcategoryData) => {
  try {
    const response = await axios.post(`${BASE_URL}api/sub-category`, subcategoryData);
    return response.data;
  } catch (error) {
    console.error("Error adding subcategory:", error);
    throw error;
  }
};
export const deleteCategory = async (categoryId) => {
  try {
    const config = {
      method: "delete",
      url: `${BASE_URL}api/category/delete-category`,
      data: { category_id:categoryId },
    };

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error("Error deleting category:", error.response?.data || error.message);
    throw error;
  }
};
export const deleteSubCategory = async (subcategoryId) => {
  try {
    const config = {
      method: "delete",
      url: `${BASE_URL}api/sub-category/delete-sub-category`,
      data: { sub_category_id:subcategoryId },
    };

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error("Error deleting category:", error.response?.data || error.message);
    throw error;
  }
};

export const updateCategoryStatus = async (categoryId, isActive) => {
  try {
    const response = await axios.put(`${BASE_URL}api/category/active-inactive-category`, {
      category_id: categoryId,
      is_active: isActive,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating category status:", error);
    throw error;
  }
};
export const updateSubcategoryStatus = async (subcategoryId, isActive) => {
  try {
    const response = await axios.put(`${BASE_URL}api/sub-category/active-inactive-sub-category`, {
      sub_category_id: subcategoryId,
      is_active: isActive,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating subcategory status:", error);
    throw error;
  }
};